export default __webpack_public_path__ + "static/dx-shift-left-testing-7754254cce6fdbfb385a18de46cd344f.png";